import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Linkedin, Instagram } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_moana-paye-module/artifacts/oaca6hlg_LOGO%20GROUPE%20AERH%20POLYNESIE%20COULEUR%20%28%C3%A0%20utiliser%20sur%20fond%20clair%29%20PNG%20%282%29.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    activités: [
      { name: 'Formations', path: '/formations' },
      { name: 'Consulting', path: '/consulting' },
      { name: 'Recrutement', path: '/recrutement' },
      { name: 'Offres d\'emploi', path: '/offres' },
      { name: 'Moana Paye', path: '/moana-paye' },
      { name: 'Location de salles', path: '/location-salles' },
    ],
    entreprise: [
      { name: 'Qui sommes-nous', path: '/a-propos' },
      { name: 'Contact', path: '/contact' },
    ],
    legal: [
      { name: 'Mentions légales', path: '/mentions-legales' },
      { name: 'CGV', path: '/cgv' },
      { name: 'CGU', path: '/cgu' },
      { name: 'Politique de confidentialité', path: '/confidentialite' },
    ],
  };

  return (
    <footer className="bg-teal-700 text-white" data-testid="main-footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img 
              src={LOGO_URL} 
              alt="Groupe AERH Polynésie" 
              className="h-20 w-auto mb-6 bg-white p-2 rounded-lg"
            />
            <p className="text-teal-100 text-sm leading-relaxed mb-6">
              Votre partenaire pour le développement des talents polynésiens. 
              Formation, consulting et recrutement au cœur de Papeete.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-teal-600 hover:bg-gold-500 flex items-center justify-center transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.linkedin.com/in/eric-aspinas-6bb5061a4/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-teal-600 hover:bg-gold-500 flex items-center justify-center transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-teal-600 hover:bg-gold-500 flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Activities Column */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-gold-400">Nos Activités</h4>
            <ul className="space-y-3">
              {footerLinks.activités.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-teal-100 hover:text-gold-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-gold-400">Entreprise</h4>
            <ul className="space-y-3">
              {footerLinks.entreprise.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-teal-100 hover:text-gold-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
            <h4 className="text-lg font-semibold mb-4 mt-8 text-gold-400">Légal</h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-teal-100 hover:text-gold-400 transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-gold-400">Contact</h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:+68987737815"
                  className="flex items-start gap-3 text-teal-100 hover:text-gold-400 transition-colors"
                >
                  <Phone className="w-5 h-5 mt-0.5 flex-shrink-0" />
                  <span>+689 87 73 78 15</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:contact@groupeaerhpolynesie.com"
                  className="flex items-start gap-3 text-teal-100 hover:text-gold-400 transition-colors"
                >
                  <Mail className="w-5 h-5 mt-0.5 flex-shrink-0" />
                  <span>contact@groupeaerhpolynesie.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-teal-100">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>10 Rue Georges Lagarde<br />Papeete, Polynésie française</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-teal-600">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-teal-200">
            <p>© {currentYear} SARL Groupe AERH Polynésie. Tous droits réservés.</p>
            <p>Créé avec passion en Polynésie française</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
